import { render, staticRenderFns } from "./StorageDrawerContent.vue?vue&type=template&id=36daf7c4&scoped=true&"
import script from "./StorageDrawerContent.vue?vue&type=script&lang=js&"
export * from "./StorageDrawerContent.vue?vue&type=script&lang=js&"
import style0 from "./StorageDrawerContent.vue?vue&type=style&index=0&id=36daf7c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36daf7c4",
  null
  
)

export default component.exports